// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5fa127cc","545":"09c31438"}[chunkId] + ".chunk.js";
};